import { Component } from '@angular/core';

@Component({
  selector: 'app-check-icon',
  templateUrl: './check-icon.component.html',
  styleUrl: './check-icon.component.scss',
})
export class CheckIconComponent {}
